import { useId } from "react";

import { Button } from "../../../ui";
import { STATE_WORDS } from "../../../ui/state";
import { isFiltering, type NavFilters } from "../model/filters";
import { FILTER_STATES } from "../model/state";

interface FilterBarProps {
  filters: NavFilters;
  onChange(next: NavFilters): void;
  people: readonly string[];
  /** A line about the result: "6 of 40 match". */
  summary?: string;
}

/** Filters by state and by person. They change what is drawn, never what is stored. */
export function FilterBar({ filters, onChange, people, summary }: FilterBarProps) {
  const stateId = useId();
  const personId = useId();
  return (
    <div className="nv-filters" role="group" aria-label="Filters">
      <div className="nv-filters__field">
        <label htmlFor={stateId}>Show only</label>
        <select id={stateId} value={filters.state} onChange={(event) => onChange({ ...filters, state: event.target.value as NavFilters["state"] })}>
          <option value="all">Every state</option>
          {FILTER_STATES.map((state) => (
            <option key={state} value={state}>
              {STATE_WORDS[state]}
            </option>
          ))}
        </select>
      </div>
      <div className="nv-filters__field">
        <label htmlFor={personId}>Work of</label>
        <select id={personId} value={filters.person} onChange={(event) => onChange({ ...filters, person: event.target.value })}>
          <option value="all">Everyone</option>
          {people.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
      {isFiltering(filters) && (
        <Button variant="quiet" onClick={() => onChange({ state: "all", person: "all" })}>
          Clear filters
        </Button>
      )}
      {summary && (
        <p role="status" className="nv-filters__summary muted">
          {summary}
        </p>
      )}
    </div>
  );
}
